<template>
  <swiper-base ref="swiper" class="swiper-type-four" :items="items" cycle="end" @change="onChange">
    <template v-slot:item="{ item }">
      <div class="swiper-type-four__slide-container">
        <slot name="item" :item="item"></slot>
      </div>
    </template>

    <template v-if="isMobileLayout" v-slot:buttons>
      <u-icon
        v-if="hasPrevButton"
        class="swiper-type-four__button swiper-type-four__button--prev"
        name="left"
        @click="onSwipe('end')"
      />
      <u-icon
        class="swiper-type-four__button swiper-type-four__button--next"
        name="right"
        @click="onSwipe('start')"
      />
    </template>

    <template v-slot:dots>
      <div class="swiper-type-four__dots dots">
        <u-icon-button
          v-if="!isMobileLayout"
          class="swiper-type-four__button swiper-type-four__button--prev"
          icon-name="left"
          size="m"
          kind="secondary"
          :disabled="!hasPrevButton"
          @click="onSwipe('end')"
        />
        <swiper-pagination-dots
          class="dots__dots"
          :total-pages="totalPages"
          :current-page-index="currentItemIndex"
          @navigate-to="navigateToPage"
        />
        <u-icon-button
          v-if="!isMobileLayout"
          class="swiper-type-four__button swiper-type-four__button--next"
          icon-name="right"
          size="m"
          kind="secondary"
          @click="onSwipe('start')"
        />
      </div>
    </template>
  </swiper-base>
</template>

<script>
import { UIconButton, UIcon } from 'universkin-shared';

import SwiperBase from '@/components/common/app-swiper/SwiperBase.vue';
import SwiperPaginationDots from '@/components/common/app-swiper/SwiperPaginationDots.vue';

export default {
  name: 'SwiperTypeFour',
  components: { SwiperBase, UIconButton, UIcon, SwiperPaginationDots },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { currentItemIndex: 0 };
  },
  computed: {
    totalPages() {
      return this.items.length;
    },
    hasPrevButton() {
      return this.currentItemIndex > 0;
    },
    isMobileLayout() {
      return this.$windowWidth.value < 960;
    }
  },
  methods: {
    onSwipe(direction) {
      const increment = direction === 'start' ? 1 : -1;
      const newValue = this.currentItemIndex + increment;
      const min = 0;
      const max = this.totalPages - 1;

      let next = newValue;

      if (newValue < min) {
        next = max;
      } else if (newValue > max) {
        next = min;
      }

      this.navigateToPage(next);
    },
    onChange(index) {
      this.currentItemIndex = index;
      this.$emit('change', index);
    },
    navigateToPage(page) {
      this.$refs.swiper.swipeToIndex(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-type-four {
  position: relative;
  --item-width: 100%;
  --item-gap: 104px;
  --expected-icon-button-size: 38px;
  display: flex;
  align-items: center;

  &__slide-container {
    padding: 0 32px;
  }

  &__button {
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    --u-icon-size: 20px;
    --u-icon-color: var(--u-color-grey-500);
    cursor: pointer;

    &:lang(ar) {
      transform: translateY(-50%) scale(-1); // swap arrow direction on button
    }
  }

  &__button--prev:not(:lang(ar)),
  &__button--next:lang(ar) {
    left: 0;
  }

  &__button--next:not(:lang(ar)),
  &__button--prev:lang(ar) {
    right: 0;
  }

  &__dots {
    margin-top: 32px;
  }
}

@media (min-width: 600px) {
  .swiper-type-four {
    &__slide-container {
      padding: 0 36px;
    }
  }
}

@media (min-width: 960px) {
  .swiper-type-four {
    &__slide-container {
      padding: 0;
    }

    &__button {
      position: static;
      transform: translateY(0);

      &:lang(ar) {
        transform: translateY(0) scale(-1); // swap arrow direction on button
      }
    }

    &__dots {
      margin: 24px 0 8px 0;
    }
  }

  .dots {
    display: flex;
    align-items: center;

    &__dots {
      margin: 0 16px;
    }
  }
}

@media (min-width: 1152px) {
  .swiper-type-four {
    &__dots {
      margin-top: 40px;
      justify-content: flex-start;
    }
  }
}
</style>
